import {UnstableCard as Paper} from '@yandex-delivery/blocks'
import {type ReactElement} from 'react'

import {AddressProvider} from '../../contexts/AddressContext'
import {hasAnyWidgetId} from '../../lib/matchSection'
import {renderWidget} from '..'
import type {FormWidgetProps as Props} from '../types'
import {VerticalsSection} from '../Verticals/index@mobile'
import * as classes from './FormWidget@mobile.classes'

export const FormWidget = (props: Props): ReactElement => {
  const {header_section, sections, bottom_section} = props.config

  return (
    <AddressProvider>
      {header_section && (
        <Paper className={classes.headerSection} padding="none" radius="L" noOverflow>
          {header_section.widgets.map(renderWidget)}
        </Paper>
      )}

      {sections.map((section, index) => (
        <Paper
          key={index}
          className={classes.bodySection}
          radius="L"
          noOverflow
        >
          {isVerticalsSection(section) ? <VerticalsSection section={section} /> : section.widgets.map(renderWidget)}
        </Paper>
      ))}

      {bottom_section && <div className={classes.bottomSectionWrapper}>{bottom_section.widgets.map(renderWidget)}</div>}
    </AddressProvider>
  )
}

const isVerticalsSection = hasAnyWidgetId('cargo_c2c_order_forms_b2b_lk_verticals_widget')
